import { FC } from 'react';

import { convertGeoJSONToGeopackage } from 'store/GeoJSONToGeopackageSlice';

import { useAppDispatch } from 'hooks/defaultStoreHooks';

import ActionDropdown from 'components/IconDropdown/ActionDropdown';

import { GeoJSONFeatureCollection } from 'ol/format/GeoJSON';

interface GeometryFileDownloadProps {
  geometry: GeoJSONFeatureCollection;
  fileName: string;
}

const downloadFile = (href: string, filename: string, type: string) => {
  // create "a" HTLM element with href to file
  const link = document.createElement('a');
  link.href = href;
  link.download = `${filename}.${type}`;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

const GeometryFileDownload: FC<GeometryFileDownloadProps> = ({ geometry, fileName }) => {
  const dispatch = useAppDispatch();

  const downloadAsGeoJSON = () => {
    const json = JSON.stringify(geometry, null, 2);
    const blob = new Blob([json], { type: 'application/geo+json' });
    const href = URL.createObjectURL(blob);
    downloadFile(href, fileName, 'json');
  };

  const downloadAsGpkg = async () => {
    const json = JSON.stringify(geometry, null, 2);
    const blob = new Blob([json], { type: 'application/json' });

    const file: File = new File([blob], '');
    const data = new FormData();
    data.append('file', file);
    const response = await dispatch(convertGeoJSONToGeopackage(data));
    if (response.meta.requestStatus == 'fulfilled' && response.payload) {
      downloadFile(response.payload as string, fileName, 'gpkg');
    }
  };

  return (
    <ActionDropdown
      icon="raa-icon-download"
      title="Ladda ner"
      headerTitle="Ladda ned som"
      xAlignment="right"
      items={[
        { text: 'Geopackage (.gpkg)', onSelect: downloadAsGpkg },
        { text: 'GeoJSON (.json)', onSelect: downloadAsGeoJSON }
      ]}
    />
  );
};

export default GeometryFileDownload;
